import { type ReactNode } from "react";

export const VARIANT = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  EXPRESSIVE: "expressive",
} as const;

export const variants = Object.values(VARIANT);
export type Variant = (typeof VARIANT)[keyof typeof VARIANT];

export const SIZE = {
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg",
} as const;

export const sizes = Object.values(SIZE);
export type Size = (typeof SIZE)[keyof typeof SIZE];

type DefaultProps<TVariant, T = object> = {
  ["data-testid"]?: string;
  children?: ReactNode;
  className?: string;
  fullWidth?: boolean;
  negative?: boolean;
  size?: Size;
  variant: TVariant | Variant;
} & T;

export type UnionParams<TVariant> =
  | DefaultProps<TVariant, { iconOnly: true; ["aria-label"]: string }>
  | DefaultProps<TVariant, { iconOnly?: false; ["aria-label"]?: string }>;

type UnionKeys<T> = T extends T ? keyof T : never;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type StrictUnionHelper<T, TAll> = T extends any
  ? T & Partial<Record<Exclude<UnionKeys<TAll>, keyof T>, never>>
  : never;

type StrictUnion<T> = StrictUnionHelper<T, T>;

export type ActionProps<TVariant extends string = Variant> = StrictUnion<UnionParams<TVariant>>;
